import React from 'react'

type PrintDataType = {
  id: string;
  //created_at: string;
  name: string;
  //note: string;
  //updated_at: string;
}

type QueueDataType = {
  id: string;
  enqueue_at: string;
  print_data_id: string;
  print_data: PrintDataType;
  progress: number;
  status: number;
  printer: any;
}

type QueueCardPropsType = {
  queue_data: QueueDataType
  handle_cancel: any
}

type GetUsePrinterProps = {
  status: number;
  printer: any;
}

const StatusList:any = {
  0: "未割当",
  1: "割り当て済み",
  2: "プリント中",
  3: "キャンセル",
  4: "プリント完了"
}

const GetUsePrinter: React.FC<GetUsePrinterProps> = ({status, printer}) => {
  if(status !== 0 && printer === null){
    return (
      <span>対象のプリンターが削除済み</span>
    )
  }else if (printer === null) {
    return (
      <span>未割当</span>
    )
  }else{
    return (
      <span>{printer.printer_name}</span>
    )
  }

}

const QueueCard: React.FC<QueueCardPropsType> = ({queue_data, handle_cancel}) => {

  return (
    <div className="bg-gray-100 border m-1 p-2 rounded-lg border-2">
      <div className="flex">
        <div className="radial-progress text-primary mr-4" style={{"--value": Math.round(queue_data.progress), "--size": "4rem"} as any} role="progressbar">{Math.round(queue_data.progress)}%</div>
        <div className="flex border-double border-l-4 border-indigo-500 pl-2">
          <div className="grid grid-cols-2">
            <span>キュー追加日:</span><span className="mr-2">{new Date(queue_data.enqueue_at).toLocaleString()}</span>
            <span>ファイル名:</span><span>{queue_data.print_data.name}</span>
          </div>
          <div className="grid grid-cols-2 border-dashed border-l-2 border-indigo-200 pl-2">
            <span>ステータス:</span><span>{StatusList[queue_data.status]}</span>
            <span>使用プリンター:</span>
            <GetUsePrinter status={queue_data.status} printer={queue_data.printer}/>
          </div>
        </div>
        <div className="mx-2 ml-auto self-center">
          {
            (queue_data.status === 2 || queue_data.status === 1) &&
              <button className="btn btn-warning" onClick={()=>{handle_cancel(queue_data)}}>Cancel</button>
          }
        </div>
      </div>
    </div>
  )

}

export default QueueCard